import { useReportData } from "src/context/ReportContext";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

export default function Report_ReportComponent_VehicleKuskiHeader({ vehicle }) {
  const { settingsData, isLoaded } = useReportData();
  const [kuskit, setKuskit] = useState([]);

  useEffect(() => {
    if (!vehicle) return;
    if (vehicle.keikkaGroup?.length === 0) return;
    let _kuskit = [];
    for (let i = 0; i < vehicle.keikkaGroup.length; i++) {
      const keikka = vehicle.keikkaGroup[i];
      for (let j = 0; j < keikka.kuskit.length; j++) {
        const kuski = keikka.kuskit[j];
        if (!_kuskit.some((k) => k.personId === kuski.personId)) _kuskit.push(kuski);
      }
    }
    setKuskit(_kuskit);
  }, [vehicle]);

  if (vehicle.keikkaGroup?.length === 0 || !isLoaded) return null;

  return (
    <div
      style={{ display: "flex", gap: 6, borderTop: "1px solid rgba(128,128,128,0.7)" }}
      className="fixPrint">
      <div
        style={{
          fontWeight: "bold",
          fontSize: settingsData.titleFontSize,
          transition: "0.3s all ease-in-out",
        }}>
        {vehicle.vehicleNo} {vehicle.vehicleRegNo}
      </div>
      <div style={{ fontSize: settingsData.titleFontSize - 2, transition: "0.3s all ease-in-out" }}>
        {kuskit?.map((kuski) => (
          <div key={kuski.personId}>
            {kuski.personFirstName} {kuski.personLastName}
          </div>
        ))}
      </div>
    </div>
  );
}

Report_ReportComponent_VehicleKuskiHeader.propTypes = {
  vehicle: PropTypes.object,
};
